import { useTranslation } from "react-i18next";

type PortalWizardStepKey =
  | "intro"
  | "supplier"
  | "exclusion"
  | "qualification"
  | "awardCriteria"
  | "minimumRequirements"
  | "documents"
  | "cover"
  | "commitment"
  | "review";

export const usePortalStepLabel = (): ((key: PortalWizardStepKey) => string) => {
  const { t } = useTranslation();
  return (key) => {
    switch (key) {
      case "intro":
        return t("About the procurement");
      case "supplier":
        return t("About the supplier");
      case "exclusion":
        return t("Grounds for exclusion");
      case "qualification":
        return t("Qualification requirements");
      case "awardCriteria":
        return t("Award criteria");
      case "minimumRequirements":
        return t("Minimum requirements");
      case "documents":
        return t("Offer documents");
      case "cover":
        return t("Cover letter");
      case "commitment":
        return t("Commitment of resources");
      case "review":
        return t("Summary and submission");
    }
  };
};

export const usePortalStepShortLabel = (): ((key: PortalWizardStepKey) => string) => {
  const { t } = useTranslation();
  return (key) => {
    switch (key) {
      case "intro":
        return t("Overview");
      case "supplier":
        return t("Supplier");
      case "exclusion":
        return t("Exclusion grounds");
      case "qualification":
        return t("Qualification");
      case "awardCriteria":
        return t("Award criteria");
      case "minimumRequirements":
        return t("Minimum requirements");
      case "documents":
        return t("Documents");
      case "cover":
        return t("Cover letter");
      case "commitment":
        return t("Commitment of resources");
      case "review":
        return t("Summary");
    }
  };
};
